import { useMemo } from 'react';
import {
  UserPlus,
  FileCheck2,
  FileSpreadsheet,
  Zap,
  ArrowRightLeft,
  Users,
  LayoutList,
  ClipboardList,
  FileText,
} from 'lucide-react';

export const useSourceDetails = (sources) => {
  const itemsWithName = useMemo(
    () =>
      new Set([
        'browser_extension_single_contact_import',
        'admin_portal_single_contact_import',
        'csv_import',
        'shared',
        'job_board',
      ]),
    [],
  );
  const items = useMemo(
    () => [
      {
        id: 1,
        title: 'Added manually by',
        sources: new Set(['browser_extension_single_contact_import', 'admin_portal_single_contact_import']),
        icon: UserPlus,
      },
      {
        id: 2,
        title: 'Applied to a job',
        sources: new Set(['job_application']),
        icon: FileCheck2,
      },
      {
        id: 3,
        title: 'Imported via CSV by',
        sources: new Set(['csv_import']),
        icon: FileSpreadsheet,
      },
      {
        id: 3,
        title: 'Job Board',
        sources: new Set(['job_board']),
        icon: LayoutList,
      },
      {
        id: 4,
        title: 'Joined Talent Network',
        sources: new Set(['tn_onboarding']),
        icon: Users,
      },
      {
        id: 5,
        title: 'Shared by',
        sources: new Set(['shared']),
        icon: ArrowRightLeft,
      },
      {
        id: 6,
        title: 'Synced from Integration / API',
        sources: new Set(['client_api_bulk_import', 'browser_extension_bulk_import']),
        icon: Zap,
      },
      {
        id: 7,
        title: 'Signed up via list form',
        sources: new Set(['list_signup']),
        icon: ClipboardList,
      },
      {
        id: 8,
        title: '',
        sources: new Set(['job_application_resume']),
        icon: FileText,
      },
    ],
    [],
  );

  // get all source that sourceDetails has
  const sourcesToRender = useMemo(
    () =>
      sources
        .map(({ source, user, addedOn, title: titleSuffix, url }, idx) => {
          const item = items.find((s) => s.sources.has(source));

          if (!item) {
            return null;
          }

          const base = { ...item, kind: source, addedOn, url, id: url ? `${item.id}-${idx}` : item.id };

          if (titleSuffix) {
            return { ...base, title: [item.title, titleSuffix].filter(Boolean).join(' ') };
          }

          if (itemsWithName.has(source)) {
            return { ...base, title: [item.title, user?.name].filter(Boolean).join(' ') };
          }

          return base;
        })
        .filter(Boolean)
        .sort((a, b) => new Date(b.addedOn) - new Date(a.addedOn)),
    [sources, items, itemsWithName],
  );

  return sourcesToRender;
};
